import React from "react";
import styled from "styled-components";

const StyledPanel = styled.div`
  padding: ${({ theme }) => theme.space[1]};
  border: ${({ theme }) => theme.borders[0]};
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: ${({ theme }) => theme.colors.white4};
  backdrop-filter: ${({ theme }) => theme.backdropFilters.default};
`;

const StyledPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => `${theme.radii[1]} ${theme.radii[1]} 0 0`};
  background-color: transparent;
`;

interface IPanelHeaderProps {
  children: React.ReactNode;
  link?: React.ReactNode;
}

const StatusPanelHeader: React.FC<IPanelHeaderProps> = ({ children, link }) => (
  <StyledPanelHeader>
    {children}
    {link}
  </StyledPanelHeader>
);

interface IPanelBodyProps {
  children: React.ReactNode;
}

const StatusPanelBody: React.FC<IPanelBodyProps> = ({ children }) => (
  <div>{children}</div>
);

interface IPanelProps {
  children?: React.ReactNode;
}

const StatusPanel = ({ children }: IPanelProps) => {
  return <StyledPanel>{children}</StyledPanel>;
};

StatusPanel.Header = StatusPanelHeader;
StatusPanel.Body = StatusPanelBody;

export default StatusPanel;
